<template>
    <div class="page-layout" v-bind:style="styles" @click="$emit('cancel', false)">
        <div class="mask"></div>
        <div class="content">
            <div class="steps">
                <div class="step">
                    <div class="step-index">1</div>
                    <div class="step-content">
                        <span>点击右上角的</span>
                        <div class="tip-more">
                        <img src="assets/wx-more.png">
                        </div>
                        <span>按钮</span>
                    </div>
                </div>
                <div class="step">
                    <div class="step-index">2</div>
                    <div class="step-content">
                        <span>选择</span>
                        <span class="tip-content">{{message}}</span>
                    </div>
                </div>
            </div>
            <div class="arrow"></div>
        </div>
    </div>
</template>

<script>
import { isIOS } from '@/common/util.js'

export default {
    data () {
        return {
            message: '在浏览器打开'
        }
    },
    props: ['show'],
    computed: {
        styles: function () {
            return {
                display: this.show ? 'block' : 'none'
            }
        }
    },
    created () {
        if (isIOS()) {
          this.message = '在Safari中打开'
        }
    }
}
</script>

<style lang="scss" scoped>
.page-layout {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2000;
    background-color: transparent;

    .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: black;
        opacity: 0.5;
    }

    .content {
        position: relative;
        width: 100%;
        height: 100%;
        color: #fff;
    }

    .steps {
        padding: 60px 20px;
    }

    .steps .step {
        color: white;
        font-size: 17px;

        * {
            display: inline-block;
            margin: 6px 2px;
        }
    }

    .step .step-index {
        width: 28px;
        height: 28px;
        border-radius: 14px;
        background-color: #FF8C00;
        text-align: center;
        line-height: 28px;
    }

    .tip-content {
        background-color: #A9A9A9;
        padding: 3px 6px;
        border-radius: 6px;
    }

    .tip-more {
        display: inline-block;
        padding: 2px;
        background-color: #A9A9A9;
        border-radius: 2px;

        img {
            width: 18px;
            height: 18px;
        }
    }

    .arrow {
        position: absolute;
        right: 0;
        top: 10px;
    }
}
</style>

